export default __webpack_public_path__ + "static/media/onboarding-bg.6f8f905e.png";